import { ArrowDownWideNarrow, ArrowUpNarrowWide } from 'lucide-react'
import React from 'react'
import { useGeckoTheme } from 'styles/GeckoTheme'

interface SortIconProps {
  sortDirection: string
}

const SortIcon: React.FC<
  SortIconProps & React.HTMLAttributes<HTMLDivElement>
> = ({ sortDirection, ...rest }) => {
  const { theme } = useGeckoTheme()

  return (
    <div {...rest}>
      {sortDirection === 'desc' ? (
        <ArrowDownWideNarrow color={theme.forecast.secondaryText} size={24} />
      ) : (
        <ArrowUpNarrowWide color={theme.forecast.secondaryText} size={24} />
      )}
    </div>
  )
}

export default SortIcon
